import Panel from './panel';
import { hideTag, showTag, tagOnClick, displayVideo, displayImage } from '../utils';

function isTouchDevice() {
  return 'ontouchstart' in document.documentElement;
}

let downloadEventFired = false;

function getiOSVersion() {
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (iOS) {
    const version = parseInt(navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)[1], 10);
    return version;
  } else {
    return false;
  }
}

export default class ReviewPanel extends Panel {
  render() {
    tagOnClick(this.getTag('retake-button'), () => {
      downloadEventFired = false;
      this.parent.transitionToPanel('video');
    });

    tagOnClick(this.getTag('share-button'), () => {
      this.parent.transitionToPanel('share');
    });
  }

  activate() {
    this.iOSVersion = getiOSVersion();
    const reviewTag = this.getTag('review-photo');
    reviewTag.element.innerHTML = '';

    const download = this.getTag('download-to-phone');
    if (!download) {
      return;
    }

    const contentType = this.parent.blobby.type;
    const mediaFn = contentType.includes('video') ? displayVideo : displayImage;
    const media = mediaFn(reviewTag, this.parent.imageDataURL);

    const match = contentType.match(/\w+\/(\w+)/);
    if (!match) {
      return;
    }
    const extension = match[1];

    if (parseInt(this.iOSVersion) < 12) {
      this.attachTouchDownload(download.element, media);
    } else {
      this.attachDownload(download.element, media, extension);
    }

    const notices = this.allTags.filter(t => t.classNames.match(/ios-download-notice/));
    notices.forEach(notice => hideTag(notice));
  }

  attachDownload(element, display, extension) {
    const link = element.querySelector('a') || document.createElement('a');
    link.href = display.src;
    link.style['-webkit-user-select'] = 'none';
    link.style['-moz-user-select'] = 'none';
    link.style['user-select'] = 'none';
    link.title = 'Download Photo';
    link.download = `ar-${new Date().getTime()}.${extension}`;
    element.prepend(link);

    element.addEventListener('click', () => {
      if (!downloadEventFired) {
        downloadEventFired = true;
        this.parent.sendEvent('download', {
          download_type: isTouchDevice() ? 'mobile_download' : 'desktop_download'
        });

        if (this.iOSVersion >= 12) {
          const notices = this.allTags.filter(t => t.classNames.match(/ios-download-notice/));
          if (notices.length > 0) {
            setTimeout(() => {
              notices.forEach(notice => showTag(notice));
            }, 500);
          }
        }
      }
    });
  }

  setDownloadMessage(message) {
    const downloadMessage = this.getTag('download-message');

    if (downloadMessage) {
      downloadMessage.element.innerHTML = message;
    }
  }

  // In order for iOS users to download an image, they have to
  // press on the image and hold lightly for a few seconds. If
  // they press too hard, force-touch kicks in and prevents the
  // download. So here, we overlay an invisible copy of the image
  // on the button and show a css-based progress bar while they
  // are holding down.
  attachTouchDownload(element, display) {
    const old = element.querySelector('.button-overlay');
    if (old) {
      old.parentNode.removeChild(old);
    }

    const overlay = display.cloneNode();
    overlay.classList.add('button-overlay');
    element.prepend(overlay);

    overlay.addEventListener('touchstart', () => {
      if (!downloadEventFired) {
        downloadEventFired = true;
        this.parent.sendEvent('download', { share_to: 'mobile_download' });
      }
      this.element.classList.add('press');
    });

    overlay.addEventListener('touchstart', () => {
      this.element.classList.add('press');
    });
    overlay.addEventListener('touchend', () => {
      this.element.classList.remove('press');
    });
    overlay.addEventListener('touchcancel', () => {
      this.element.classList.remove('press');
    });

    overlay.addEventListener('touchforcechange', event => {
      var force = event.changedTouches[0].force;
      if (force > 0.1) {
        event.preventDefault();
        this.element.classList.remove('press');
        this.element.classList.add('too-hard');
        this.setDownloadMessage('Press lightly!');
      } else {
        this.element.classList.remove('too-hard');
        this.setDownloadMessage('Hold to download');
      }
    });
  }
}
